import ContextAuthModels from "./ContextAuth"
import ContextNavModels from "./ContextNav"

export default function ContextContainer(props: any) {

    return (
        <>
            <ContextAuthModels>
                <ContextNavModels>
                    {props.children}
                </ContextNavModels>
            </ContextAuthModels>
        </>
    )
}